import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import CustomerID from '@/App/Customer/Entity/CustomerID'
import {
    type CustomerData,
    type CustomerProfilePictureFile,
} from '@/Shared/AutoGenerated/Main'

export default class Customer {
    constructor(
        public readonly id: CustomerID,
        public readonly firstName: string,
        public readonly lastName: string | null,
        public readonly email: string,
        public readonly profilePicture: CustomerProfilePictureFile | null,
    ) {
        ensureNoUndefinedProperties(this)
    }

    getFullName(): string {
        return `${this.firstName} ${this.lastName ?? ''}`.trim()
    }

    getProfilePictureUrlWithFallback(): string {
        return this.profilePicture?.url ?? '/static/images/profile.png'
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingleOrNull(
        entityData: CustomerData | null,
    ): Customer | null {
        if (!entityData) {
            return null
        }

        return this.hydrateSingle(entityData)
    }

    static hydrateSingle(entityData: CustomerData): Customer {
        return new Customer(
            new CustomerID(entityData.id),
            entityData.firstName,
            entityData.lastName,
            entityData.email,
            entityData.profilePicture,
        )
    }

    static hydrateMultiple(entitiesData: CustomerData[]): Customer[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
